import { ArrowRight } from "lucide-react";
import { ASSETS } from "@/lib/assets";
import { Reveal, SplitLines } from "./motion";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="px-6 pt-10 pb-6">
    <div className="mx-auto max-w-7xl relative rounded-[2.5rem] bg-[var(--ink)] text-white px-8 sm:px-16 py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-[0.12] [background-image:radial-gradient(rgba(255,255,255,0.5)_1px,transparent_1px)]" />
      <div className="absolute -right-32 -bottom-32 h-[28rem] w-[28rem] rounded-full bg-[var(--blue)] blur-[120px] opacity-60" />
      <div className="absolute -left-20 -top-20 h-72 w-72 rounded-full bg-[var(--orange)] blur-[100px] opacity-40" />
      <div className="relative max-w-3xl">
        <Reveal y={16} className="eyebrow !text-[var(--orange)] before:!bg-[var(--orange)] mb-8">Chega de esperar</Reveal>
        <SplitLines as="h2" inView className="font-display font-bold tracking-[-0.035em] leading-[0.95] text-4xl sm:text-5xl lg:text-7xl" lines={["Sua próxima landing", "está a um clique."]} />
        <Reveal delay={0.25} className="mt-8 text-slate-300 text-base sm:text-lg max-w-xl leading-relaxed">
          Cole o HTML, edite clicando, publique. Teste grátis, cancele quando quiser.
        </Reveal>
        <Reveal delay={0.35} className="mt-10 flex flex-wrap gap-4">
          <a href="/register" data-testid="final-cta-button" className="btn btn-primary !bg-white !text-[var(--ink)] hover:!bg-[var(--orange)] hover:!text-white">
            Começar grátis agora <ArrowRight size={18} className="arrow" />
          </a>
          <a href="#planos" data-testid="final-cta-plans" className="btn btn-ghost !bg-white/5 !text-white !border-white/15 hover:!bg-white/10 hover:!text-white">Ver planos</a>
        </Reveal>
      </div>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="px-6 py-14">
    <div className="mx-auto max-w-7xl flex flex-col md:flex-row items-start md:items-center justify-between gap-8 text-sm text-slate-500">
      <img src={ASSETS.logo} alt="Lowpages" className="h-7 w-auto" />
      <nav className="flex flex-wrap gap-x-7 gap-y-3">
        {[["#como-funciona", "Como funciona"], ["#recursos", "Recursos"], ["#planos", "Planos"], ["#faq", "FAQ"], ["#", "Termos"], ["#", "Privacidade"]].map(([h, l]) => (
          <a key={l} href={h} className="hover:text-[var(--blue)] transition-colors">{l}</a>
        ))}
      </nav>
      <span className="font-mono text-xs">© 2026 Lowpages. Da sua IA para o ar.</span>
    </div>
  </footer>
);
